import reducer from './brand-reducer';

export default reducer;
export { initialState } from './brand-reducer';

export * from './brand-actions';
